import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";

const HomeSectionSubTitle: FCX = ({
    children,
    className,
    style,
    testId,
}) => {
    return (
        <div
            className={cn('HomeSection__sub-title', className)}
            style={style}
            data-testid={testId}
        >
            {children}
        </div>
    );
};

export default HomeSectionSubTitle;